module.exports = "./img/desktop_logo.9fc9e5b.png";